import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SalesLinkGenerator from './components/SalesLinkGenerator';
import AdminConsole from './components/AdminConsole';
import ScholarshipPortalSupabase from './components/ScholarshipPortalSupabase';
import AdminLogin from './components/AdminLogin';      // <-- use your new component
import { supabase } from './supabaseClient';

function ProtectedRoute({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setSession(session);
      setLoading(false);
      if (!session) navigate('/admin-login');   // redirect to your custom login
    };
    getSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) navigate('/admin-login');
    });
    return () => authListener?.subscription.unsubscribe();
  }, [navigate]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  return session ? children : null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/sales" />} />
        <Route path="/sales" element={<SalesLinkGenerator />} />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminConsole />
          </ProtectedRoute>
        } />
        <Route path="/admin-login" element={<AdminLogin />} />   {/* new route */}
        <Route path="/scholarship" element={<ScholarshipPortalSupabase />} />
        <Route path="*" element={<Navigate to="/sales" />} />
      </Routes>
    </Router>
  );
}

export default App;